import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-meal-plan-editor',
  templateUrl: './meal-plan-editor.component.html',
  styleUrls: ['./meal-plan-editor.component.scss']
})
export class MealPlanEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
